import React, { memo } from "react";
import Markdown from "react-markdown";
import { privacyAgreement } from "@/pages/Index/doc/content";


interface Props {
}

const Privacy: React.FC<Props> = memo(() => {

  return (
    <div className={"p-10 overflow-auto"}>
      <Markdown>
        {privacyAgreement}
      </Markdown>
    </div>
  );
});

export default Privacy;
